export const themeGenerator = (createTheme, mode = 'light') => {
	return createTheme({
		palette: {
			mode,
			type: mode,
			primary: {
				main: '#3a5a40',
				light: '#588157',
				dark: '#344e41',
			},
			secondary: {
				main: '#dda15e',
			},
		},
	});
};

export function setWithExpiry(key, value, ttlMs) {
	const item = {
		value,
		expiresAt: Date.now() + ttlMs,
	};
	localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
	const json = localStorage.getItem(key);
	if (!json) return null;
	try {
		const item = JSON.parse(json);
		if (Date.now() > item.expiresAt) {
			localStorage.removeItem(key);
			return null;
		}
		return item.value;
	} catch {
		localStorage.removeItem(key);
		return null;
	}
}

export function setSessionValue(key, value) {
	sessionStorage.setItem(key, JSON.stringify(value));
}

export function getSessionValue(key) {
	const json = sessionStorage.getItem(key);
	if (!json) return null;
	try {
		return JSON.parse(json);
	} catch {
		sessionStorage.removeItem(key);
		return null;
	}
}

export function removeSessionValue(key) {
	sessionStorage.removeItem(key);
}
